import api from 'api';

export const loadTags = (data, { signal }) =>
  api('GET /api/conversion-pages/fields/tags')(data, {
    deduplicatorTimeout: 10,
    signal,
  });
